import { useMemo } from 'react'

import EntitiesSelector from './EntitiesSelector'
import { isObject } from '../../../utils'

const AssistantsSelector = ({ className = '', empty = false, disabled, reverse = false, assistants = [], style = {}, values = [], dropdownRender, onChange }) => {
  const entityOptions = useMemo(() => assistants.map(a => {
    let label = `${a.lastname} ${a.firstname}`

    if (isObject(a.schoolSpeciality) && isObject(a.schoolSpeciality.specialityYear)) {
      label += ` - ${a.schoolSpeciality.specialityYear.specialityAbbreviation} (${a.schoolSpeciality.specialityYear.studyYearName})`
    }

    return { value: a.id, entity: a, label, tooltip: label }
  }), [assistants, reverse])

  return (
    <EntitiesSelector
      className={className}
      disabled={disabled}
      entityOptions={entityOptions}
      multiple='default'
      showSearch
      style={style}
      values={values}
      onChange={onChange}
      empty={empty}
    />
  )
}

export default AssistantsSelector
